import { EncryptionApi, HttpClientApi } from '@juvare/platform-app/Integration';
import { AwsConfig, JnetRequestData } from './types';
import { awsConfigSchema, jnetResponseSchema } from './validation';

export class BackgroundCheckClient {
    #encryption: EncryptionApi;
    #httpClient: HttpClientApi;
    #awsConfig: AwsConfig;
    #jnetURL: string;

    constructor({
        encryption,
        httpClient,
        awsConfig,
        jasBaseURL,
    }: {
        encryption: EncryptionApi;
        httpClient: HttpClientApi;
        awsConfig: Partial<AwsConfig>;
        jasBaseURL: string;
    }) {
        this.#awsConfig = awsConfigSchema.parse(awsConfig);
        this.#encryption = encryption;
        this.#httpClient = httpClient;
        this.#jnetURL = `${jasBaseURL}/background-checks/jnet-request`;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    #getSignedHeaders({ httpMethod, uri, body }: { httpMethod: 'POST'; uri: string; body?: any }) {
        const config = {
            ...this.#awsConfig,
            uri,
            httpMethod,
            body,
        };
        return this.#encryption.awsSignV4(config);
    }

    requestJNet(data: JnetRequestData) {
        const uri = this.#jnetURL;

        const { code, body, errorBody } = this.#httpClient.post(uri, data, this.#getSignedHeaders({ httpMethod: 'POST', uri, body: data }));

        if (code !== 200) {
            throw Error(errorBody);
        }

        if (!body) {
            throw Error('There is no body returned');
        }

        const parsedBody = jnetResponseSchema.parse(body);

        return { result: parsedBody.result, requestId: parsedBody.requestId };
    }
}
